import { ref } from "vue";

const isMenuVisible = ref(true);

export function useMenuController() {
  function showMenu() {
    isMenuVisible.value = true;
  }

  function hideMenu() {
    isMenuVisible.value = false;
  }

  return {
    isMenuVisible,
    showMenu,
    hideMenu,
  };
}
